import type { MouseEventHandler } from "react";
import { type PropsWithChildren, type ReactNode } from "react";

import Close from "@assets/images/close-icon.svg?react";
import classNames from "classnames";

import "./style.scss";
import useMediaQuery from "@/hooks/useMediaQuery";

interface ModalBtnWrapperProps extends PropsWithChildren {
	align?: "left" | "center" | "right";
}
export function ModalBtnWrapper({ align = "center", children }: ModalBtnWrapperProps) {
	return (
		<div className={classNames("btn-wrapper", { [`align-${align}`]: align })}>{children}</div>
	);
}

export function ModalContent({ children, className }: PropsWithChildren & { className?: string }) {
	return <div className={classNames(`modal-content`, className)}>{children}</div>;
}

export function ModalTitle({
	title,
	onClose,
	className,
}: {
	title: string;
	onClose?: MouseEventHandler;
	className?: string;
}) {
	return (
		<div className={classNames("modal-title", className)}>
			<h3>{title}</h3>
			{onClose && <ModalClose onClose={onClose} />}
		</div>
	);
}
export function ModalClose({ onClose }: { onClose?: MouseEventHandler }) {
	return <Close className="modal-close" onClick={onClose} />;
}

export function ModalWrapper({
	children,
	className,
	maxWidth = 400,
	onClose,
}: {
	children: ReactNode;
	className?: string;
	maxWidth?: number;
	onClose?: MouseEventHandler;
}) {
	const isMobile = useMediaQuery("(max-width: 768px)");
	const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
		onClose?.(e);
	};
	const width = isMobile ? "100%" : maxWidth;
	return (
		<div className="modal-wrapper" onClick={handleBackdropClick}>
			<div
				onClick={(e) => e.stopPropagation()}
				className={classNames("modal-wrapper__box", {
					"is-mobile": isMobile,
					[className || ""]: className,
				})}
				style={{ maxWidth: width }}
			>
				<div className="modal-body">{children}</div>
			</div>
		</div>
	);
}
